export default class MouseFlow {
  static init() {
    window._mfq = window._mfq || [];
  }
  static push(name, path, unique = false) {
    window._mfq = window._mfq || [];
    if (typeof name !== 'string' || typeof path !== 'string') {
      throw new Error('MouseFlow push method all params must be strings');
    }
    const hasAlready = () => {
      try {
        return window._mfq.filter((i) => i[0] === name && i[1] === path).length > 0;
      } catch (e) {
        return false;
      }
    };
    if (unique && hasAlready()) return;
    window._mfq.push([name, path]);
  }
}
